import { createContext, useContext } from 'react';

import type { DialogState, DialogFormData, DialogStep } from '../../types';

/**
 * Dialog context actions interface
 */
export interface DialogActions {
  updateFormData: (data: Partial<DialogFormData>) => void;
  goToStep: (step: DialogStep) => void;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  submitDialog: () => Promise<void>;
  cancelDialog: () => void;
}

/**
 * Dialog context value interface
 */
export interface DialogContextValue {
  state: DialogState;
  actions: DialogActions;
  isEditMode: boolean;
  isDuplicateMode: boolean;
}

/**
 * Dialog context
 */
export const DialogContext = createContext<DialogContextValue | undefined>(undefined);

/**
 * Hook to access dialog context
 */
export function useDialogContext(): DialogContextValue {
  const context = useContext(DialogContext);

  if (!context) {
    throw new Error('useDialogContext must be used within a DialogProvider');
  }

  return context;
}
